import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  InitialVoucherReportsFilterData,
  InitialVoucherReportsFilterDataVariables
} from "./types/InitialVoucherReportsFilterData";
import { VoucherReport, VoucherReportVariables } from "./types/VoucherReport";

export const voucherQuery = gql`
  ${pageInfoFragment}
  query VoucherReport(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: VoucherReportFilterInput!
  ) {
    voucherReport(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          voucher_id
          voucher_code
          order_code
          first_name
          last_name
          mall_name
          total_net_amount
          discount_value
          status
          shipping_method_name
          payment_method_type
        }
      }
    }
  }
`;
export const useVoucherReportsListQuery = makeBossQuery<
  VoucherReport,
  VoucherReportVariables
>(voucherQuery);

export const initialVoucherReportsFilterDataQuery = gql`
  query InitialVoucherReportsFilterData($brand: [ID], $mall: [ID]) {
    brands(first: 5, filter: { id: $brand }) {
      edges {
        node {
          id
          name
        }
      }
    }

    malls(first: 5, filter: { id: $mall }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const useInitialVoucherReportsFilterDataQuery = makeQuery<
  InitialVoucherReportsFilterData,
  InitialVoucherReportsFilterDataVariables
>(initialVoucherReportsFilterDataQuery);
